import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { Product, Intro } from "../components";

import { fetchProduct } from "../actions/products";
import { methodPay } from "../actions/cart";

const Checkout = () => {
  const dispatch = useDispatch();
  const items = useSelector(({ products }) => products.items);
  const cartItems = useSelector(({ cart }) => cart.items);
  const isLoaded = useSelector(({ products }) => products.isLoaded);

  React.useEffect(() => {
    document.title = 'theMAP-Store | Checkout';
    dispatch(fetchProduct());
    dispatch(methodPay('checkout'));
  }, []);

  const handleAddProductToCart = (obj) => {
    dispatch({
      type: "ADD_PRODUCT_CART",
      payload: obj,
    });
  };

  return (
    <div className="container">
      <Intro />
      <div className="content__items grid between center">
        {isLoaded
          ? items.map((obj) => (
              <Product
                onClickAddProduct={handleAddProductToCart}
                key={obj.id}
                addedCount={cartItems[obj.id] && cartItems[obj.id].items.length}
                {...obj}
              />
            ))
          : ""}
      </div>
    </div>
  );
};

export default Checkout;
